module.exports = __webpack_public_path__ + "47b35b7c398f76971476071f34293124.pdf";